/**
 * Production-only service worker registration for PWA installability.
 * Failure is non-fatal and must never block React bootstrap / auth / WebSocket.
 */

const SERVICE_WORKER_URL = `${process.env.PUBLIC_URL || ''}/service-worker.js`;
const SAFE_NOTIFICATION_PATH = '/notifications';

function isSafeInternalNotificationPath(url) {
  return url === SAFE_NOTIFICATION_PATH;
}

function installNotificationNavigateListener() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }
  if (typeof navigator.serviceWorker.addEventListener !== 'function') {
    return;
  }
  if (navigator.serviceWorker.__riestroNotificationNavigateBound) {
    return;
  }
  navigator.serviceWorker.__riestroNotificationNavigateBound = true;
  navigator.serviceWorker.addEventListener('message', (event) => {
    const data = event && event.data;
    if (!data || data.type !== 'riestro_notification_navigate') {
      return;
    }
    if (!isSafeInternalNotificationPath(data.url)) {
      return;
    }
    try {
      if (window.location.pathname !== SAFE_NOTIFICATION_PATH) {
        window.location.assign(SAFE_NOTIFICATION_PATH);
      }
    } catch (_err) {
      // fail closed
    }
  });
}

export function registerServiceWorker() {
  if (process.env.NODE_ENV !== 'production') {
    return Promise.resolve(null);
  }

  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return Promise.resolve(null);
  }

  installNotificationNavigateListener();

  return navigator.serviceWorker
    .register(SERVICE_WORKER_URL)
    .catch(() => null);
}
